import { render, staticRenderFns } from "./ProductHeaderKonami.vue?vue&type=template&id=56c84c26&scoped=true&"
import script from "./ProductHeaderKonami.vue?vue&type=script&lang=js&"
export * from "./ProductHeaderKonami.vue?vue&type=script&lang=js&"
import style0 from "./ProductHeaderKonami.vue?vue&type=style&index=0&id=56c84c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c84c26",
  null
  
)

export default component.exports